import { render } from "./OidcAuth.vue?vue&type=template&id=78eda033"
import script from "./OidcAuth.vue?vue&type=script&lang=js"
export * from "./OidcAuth.vue?vue&type=script&lang=js"

import "./OidcAuth.vue?vue&type=style&index=0&id=78eda033&lang=css"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__